//export const BACKEND_URL = "http://localhost:5000"
export const BACKEND_URL = "https://game3d.onrender.com"